const opts = {
  // root: document.documentElement,
  // rootMargin: '0px',
  // threshold: .1,
};

const observer = new IntersectionObserver(onObserve, opts);
const cbs = new WeakMap();

export function onAppear ($el, fn = '--appear', { once = true } = {}) {
  if (Array.isArray($el))
    $el.forEach(_each);
  else
    _each($el);

  function _each ($el) {
    cbs.set($el, { fn, once });
    observer.observe($el);
  }

  return offAppear.bind(null, $el);
}

function onObserve (entries) {
  entries.forEach(entry => {
    if (!entry.isIntersecting)
      return;
    const { fn, once } = cbs.get(entry.target);
    if (fn) {
      if (typeof fn === 'function')
        fn(entry);
      else if (typeof fn === 'string')
        entry.target.classList.add(fn);

      if (once !== false)
        offAppear(entry.target);
    }
  });
}

function offAppear ($el) {
  cbs.delete($el);
  observer.unobserve($el);
}
